import { createFileRoute } from "@tanstack/react-router";
import { permanentRedirect } from "@/lib/routeRedirect";

// Legacy URL: Client Accounts now lives at /admin/client-accounts.
export const Route = createFileRoute("/_admin/admin/client-contacts")({
  beforeLoad: permanentRedirect("/admin/client-accounts"),
});
